import { render, staticRenderFns } from "./ingresa_monto.vue?vue&type=template&id=6b361b3a&scoped=true&"
import script from "./ingresa_monto.vue?vue&type=script&lang=ts&"
export * from "./ingresa_monto.vue?vue&type=script&lang=ts&"
import style0 from "./ingresa_monto.vue?vue&type=style&index=0&id=6b361b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b361b3a",
  null
  
)

export default component.exports